export default {
    methods: {
        changeStock(id, value) {
            return new Promise(async (resolve, reject) => {
                try {
                    const lot = await this.$gestios.items('lots').get(id)

                    let quantity = ''
                    if (lot.ok) {
                        quantity = lot.data.quantity + value

                        const result = await this.$gestios
                            .items('lots')
                            .edit({ id: id, params: { quantity: quantity } })
                        resolve(result.data)
                    } else {
                        reject(new Error('Lote no encontrado'))
                    }

                    resolve()
                } catch (err) {
                    reject(err)
                }
            })
        },
        calibrateStock(newConcepts, oldConcepts = []) {
            return new Promise(async (resolve, reject) => {
                try {
                    let newProducts = {}
                    let oldProducts = {}
                    let finalProducts = {}

                    newConcepts.forEach((concept) => {
                        const lot = concept.lot
                        if (!newProducts[lot]) newProducts[lot] = 0
                        newProducts[lot] += concept.quantity
                    })

                    if (oldConcepts.length > 0) {
                        oldConcepts.forEach((concept) => {
                            const lot = concept.lot.key
                            if (!oldProducts[lot]) oldProducts[lot] = 0
                            oldProducts[lot] += concept.quantity
                        })

                        Object.keys(newProducts).forEach((lot) => {
                            if (oldProducts[lot]) {
                                finalProducts[lot] = newProducts[lot] - oldProducts[lot]
                            } else {
                                finalProducts[lot] = newProducts[lot]
                            }
                        })

                        Object.keys(oldProducts).forEach((lot) => {
                            if (!finalProducts[lot]) {
                                if (newProducts[lot]) {
                                    finalProducts[lot] = newProducts[lot] - oldProducts[lot]
                                } else {
                                    finalProducts[lot] = -oldProducts[lot]
                                }
                            }
                        })
                    } else {
                        finalProducts = newProducts
                    }

                    const data = Object.fromEntries(
                        Object.entries(finalProducts)
                            .filter((lot) => {
                                return lot[1] !== 0
                            })
                            .map((d) => {
                                d[1] = -d[1]
                                return d
                            })
                    )

                    for (let i = 0; i < Object.keys(data).length; i++) {
                        const lot = Object.keys(data)[i]
                        const value = data[lot]

                        await this.changeStock(lot, value)
                    }

                    resolve(true)
                } catch (err) {
                    reject(err)
                }
            })
        },
    },
}
